import { PERMISOS_CARGA_MASIVA, PERMISOS_CONFIRMING } from '@shared/constants/permisos';
import { PestanaNavegacion } from '@shared/componentes/pestanas-navegacion/pestanas-navegacion.constants';
import { RUTAS_CONFIRMING } from '@shared/constants/rutas-confirming.constants';
import { BREADCRUMBS_MAPEO_CAMPOS } from '@mapeo-campos/constants/mapeo-campos.constants';
import { TIPO_ARCHIVO_MAPEO } from '@mapeo-campos/enums/tipo-archivo-mapeo.enum';

export const RUTAS_CARGA_MASIVA = {
  FACTURAS: `${RUTAS_CONFIRMING.CARGA_MASIVA}/${TIPO_ARCHIVO_MAPEO.FACTURAS}`,
  PROVEEDORES: `${RUTAS_CONFIRMING.CARGA_MASIVA}/${TIPO_ARCHIVO_MAPEO.PROVEEDORES}`,
  INFORMACION_BANCARIA: `${RUTAS_CONFIRMING.CARGA_MASIVA}/${TIPO_ARCHIVO_MAPEO.INFORMACION_BANCARIA}`
} as const;

export const PESTANAS_CARGA_MASIVA: readonly PestanaNavegacion[] = [
  {
    id: TIPO_ARCHIVO_MAPEO.FACTURAS,
    titulo: BREADCRUMBS_MAPEO_CAMPOS.FACTURAS,
    ruta: RUTAS_CARGA_MASIVA.FACTURAS,
    permisos: [PERMISOS_CONFIRMING.PREPARAR]
  },
  {
    id: TIPO_ARCHIVO_MAPEO.PROVEEDORES,
    titulo: BREADCRUMBS_MAPEO_CAMPOS.PROVEEDORES,
    ruta: RUTAS_CARGA_MASIVA.PROVEEDORES,
    permisos: PERMISOS_CARGA_MASIVA
  },
  {
    id: TIPO_ARCHIVO_MAPEO.INFORMACION_BANCARIA,
    titulo: BREADCRUMBS_MAPEO_CAMPOS.INFORMACION_BANCARIA,
    ruta: RUTAS_CARGA_MASIVA.INFORMACION_BANCARIA,
    permisos: PERMISOS_CARGA_MASIVA
  }
];
